var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/** Builds the exact Consumer shape available before public Country support was added. */
export var projectLegacyCheckoutConsumer = function (consumer) {
    if (!consumer) {
        return undefined;
    }
    return __assign(__assign(__assign(__assign(__assign(__assign({}, (consumer.emailAddress !== undefined ? { emailAddress: consumer.emailAddress } : {})), (consumer.firstName !== undefined ? { firstName: consumer.firstName } : {})), (consumer.lastName !== undefined ? { lastName: consumer.lastName } : {})), (consumer.nationalIdentifier !== undefined ? { nationalIdentifier: consumer.nationalIdentifier } : {})), (consumer.mobileNumber !== undefined
        ? {
            mobileNumber: {
                countryCode: consumer.mobileNumber.countryCode,
                phoneNumber: consumer.mobileNumber.phoneNumber,
            },
        }
        : {})), (consumer.consumerIdentity !== undefined
        ? {
            consumerIdentity: __assign(__assign(__assign({ identityValue: consumer.consumerIdentity.identityValue }, (consumer.consumerIdentity.identityProvider !== undefined
                ? { identityProvider: consumer.consumerIdentity.identityProvider }
                : {})), (consumer.consumerIdentity.identityType !== undefined
                ? { identityType: consumer.consumerIdentity.identityType }
                : {})), (consumer.consumerIdentity.type !== undefined ? { type: consumer.consumerIdentity.type } : {})),
        }
        : {}));
};
